import { useState } from "react";
import Button from "./Button";
import '../../styles/ui/modal.scss'


const Modal = ({children, component}) => {
    
    const [modal, setModal] = useState(false)
    const changeModal = (value) => {
        setModal(value)
    }

    return (
        <div className="modal-container">
            {
                modal && 
                <div className="modal-wrapper">
                    <div className="component-wrapper">
                    {
                        component
                    }
                    </div>
                    <Button
                        text="Close"
                        type="gradient"
                        onClick = {()=>changeModal(false)}
                    />
                </div>
            }
            <div className="modal-button" onClick={()=>changeModal(true)}>
                { children }
            </div>
        </div>
    )
}

export default Modal;